<template>
  <section>
    <!-- 行业标准 -->
    <v-sub_banner :msgObj="subBannerInfo"></v-sub_banner>
    <b-container fluid>
      <b-row class="justify-content-center newCenter">
        <b-col cols="12" sm="11" md="9" xl="8">
          <div class="industrial">
            <p class="desc" style="text-align: justify;">{{ description }}</p>
            <div class="showBox">
              <vue-flex-waterfall
                class="custom-class"
                :col="colNum"
                :col-spacing="10"
                :break-at="breakAt"
                :break-by-container="true"
                style="align-content: center"
              >
                <div
                  v-for="(item, index) in showData"
                  :key="index"
                  class="itemBox"
                  
                >
                  <h3 style="text-align: justify;">{{ item.title }}</h3>
                  <p >
                    <a>{{ item.btnName }}</a>
                    <span>{{ item.status }}</span>
                  </p>
                </div>
              </vue-flex-waterfall>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import VueFlexWaterfall from "vue-flex-waterfall";
import Sub_banner from "../sub-banner.vue";
export default {
  components: {
    "v-sub_banner": Sub_banner,
    VueFlexWaterfall,
  },
  props: {
    col: {
      type: Number,
      default: 1,
    },
    colSpacing: {
      type: [Number, String],
      default: 0,
    },
    breakAt: {
      type: Object,
      default: () => ({}), //{ 575: 1, 767: 2, 1920: 3 }
    },
    breakByContainer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      subBannerInfo: {
        img: require("@/assets/images/e-gov_banner.png"),
        title: "行业标准编制",
        subTitle: "Industry standards compilation ",
      },
      colNum: 1,
      description:
        "近年来，信息中心围绕安全监管、公共服务和政务办公三大领域，开展无人机实名登记系统数据交换交换规范、民航旅客行李全流程跟踪技术规范、航空物流信息规范、民用航空电子政务数据交换规范等10余项行业标准编制工作，已在中国航协发布团体标准3项。",
      showData: [
        {
          title: "民用无人驾驶航空器实名登记数据交换接口规范",
          btnName: "行业标准",
          status: "已发布",
        },
        {
          title: "民航旅客行李全流程跟踪技术规范 第1部分：机场端建设指南",
          btnName: "行业标准",
          status: "已发布",
        },
        {
          title:
            "民用航空电子政务数据接口规范（第1部分：民航数据共享与交换接口规范）",
          btnName: "行业标准",
          status: "制定中",
        },
        {
          title:
            "民用航空电子政务数据接口规范（第2部分：民航统一认证对接标准规范）",
          btnName: "行业标准",
          status: "已发布",
        },
        {
          title:
            "民用航空电子政务数据接口规范（第3部分：民航行政审批服务平台接口对接规范）",
          btnName: "行业标准",
          status: "已发布",
        },
        {
          title:
            "民用航空电子政务数据接口规范（第4部分：民航行业监管事项库及执法处理数据接口规范）",
          btnName: "行业标准",
          status: "已发布",
        },
        {
          title: "航空物流信息规范（第1部分：国内电子运单）",
          btnName: "行业标准",
          status: "制定中",
        },
        {
          title: "航空物流信息规范（第2部分：信息流程）",
          btnName: "行业标准",
          status: "制定中",
        },
        {
          title: "航空物流信息规范（第3部分：流程数据）",
          btnName: "行业标准",
          status: "制定中",
        },
        {
          title: "航空物流信息规范（第4部分：数据接口）",
          btnName: "行业标准",
          status: "制定中",
        },
        {
          title: "航空物流信息交换规范 第1部分：信息流程(T/CATAGS 22.1—2020)",
          btnName: "团体标准",
          status: "2020.12.31",
        },
        {
          title: "航空物流信息交换规范 第2部分：流程数据(T/CATAGS 22.2—2020)",
          btnName: "团体标准",
          status: "2020.12.31",
        },
        {
          title: "航空物流信息交换规范 第3部分：数据接口(T/CATAGS 22.3—2020)",
          btnName: "团体标准",
          status: "2020.12.31",
        },
        {
          title:
            "基于可扩展置标语言的民航电子政务电子公文格式规范(MH/T 0038-2012)",
          btnName: "行业标准",
          status: "2020.04.16",
        },
        {
          title:"危险品航空运输鉴定报告数据接口规范",
          btnName: "行业标准",
          status: "已立项",
        },
        {
          title:"航空货运信息规范 第1部分：国内电子运单",
          btnName: "行业标准",
          status: "制定中",
        },
        {
          title:"航空货运信息规范 第2部分：信息交互流程",
          btnName: "行业标准",
          status: "制定中",
        },
        {
          title:"航空货运信息规范 第3部分：交互数据定义",
          btnName: "行业标准",
          status: "制定中",
        },
        {
          title:"航空货运信息规范 第4部分：数据报文接口",
          btnName: "行业标准",
          status: "制定中",
        },
        {
          title:"航空货运信息规范 第5部分：安检电子放行",
          btnName: "行业标准",
          status: "制定中",
        },
        {
          title:"航空货运信息规范 第6部分：安检信息电子化",
          btnName: "行业标准",
          status: "制定中",
        },
        {
          title:"民航行政审批服务平台接口对接规范",
          btnName: "行业标准",
          status: "申请报批",
        },
        {
          title:"电子政务综合办公平台数据接口规范",
          btnName: "行业标准",
          status: "制定中",
        },
        {
          title:"民航旅客行李全流程跟踪技术规范（第1部分：机场端建设指南）",
          btnName: "行业标准",
          status: "已发布",
        },
        {
          title:"民航政务数据共享与交换技术要求",
          btnName: "行业标准",
          status: "申请报批",
        },
        {
          title:"民用航空数据分类分级指南",
          btnName: "行业标准",
          status: "已立项",
        },
        {
          title:"民用航空数据安全监测预警技术要求",
          btnName: "行业标准",
          status: "已立项",
        },
        {
          title:"民航行业监管事项库及执法处理数据接口规范",
          btnName: "行业标准",
          status: "审评报批",
        },
        {
          title:"民航统一认证接口规范",
          btnName: "行业标准",
          status: "申请报批",
        },
        {
          title:"民用航空飞行员资质安全符合性数据交换规范",
          btnName: "行业标准",
          status: "制定中",
        },
      ],
    };
  },
  mounted() {
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      console.log("自执行");
      let screenWidth = window.innerWidth;
      this.setReSize(screenWidth);
    };
    // 初始化时执行一次,设置瀑布流列数
    this.setReSize(window.innerWidth);
  },
  methods: {
    setReSize(screenWidth) {
      if (screenWidth > 576) {
        this.subBannerInfo.img = require("@/assets/images/e-gov_banner.png");
        if (screenWidth <= 768) {
          this.colNum = 2;
        } else if (screenWidth < 992) {
          this.colNum = 3;
        } else if (screenWidth >= 992) {
          this.colNum = 3;
        }
      } else {
        this.subBannerInfo.img = require("@/assets/images/e-m.png");
        this.colNum = 1;
      }
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/industrial.css";
</style>
<style lang="less">
@media (max-width: 575px) {
  .industrial {
    padding: 30px 40px 100px;
    
    .desc {
      text-align: left;
      font-size: 14px;
      line-height: 2.5;
    }
    .showBox {
   
      /* flex-direction: column; */
      .itemBox {
        width: 96%;
        margin-bottom: 30px;
        h3 {
          font-size: 14px;
          line-height: 2;
          text-align: left;
        }
        p {
          padding-top: 14px;
          a,
          span {
            font-size: 14px;
            line-height: 2;
          }
        }
      }
         margin-top:30px;
    }
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .industrial {
    padding: 80px 20px 100px;
    .desc {
      text-align: left;
      font-size: 14px;
      line-height: 2.5;
    }
    .showBox {
      display: flex;
      .itemBox {
        width: 38%;
        margin-right: 3%;
        margin-bottom: 30px;
        h3 {
          font-size: 16px;
          line-height: 2;
          text-align: left;
        }
        p {
          padding-top: 15px;
          a,
          span {
            font-size: 14px;
            line-height: 2;
          }
        }
      }
      .itemBox:nth-child(2n) {
        margin-right: 0;
      }
    }
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .industrial {
    padding: 80px 20px 100px;
    .desc {
      text-align: left;
      font-size: 14px;
      line-height: 2.5;
    }
    .showBox {
      /* display: flex; */
      width: 100%;

      .itemBox {
        width: 29%;

        margin-right: 4%;
        margin-bottom: 30px;
        h3 {
          font-size: 16px;
          line-height: 2;
          text-align: left;
        }
        p {
          padding-top: 15px;
          a,
          span {
            font-size: 14px;
            line-height: 2;
          }
        }
      }
      /* .itemBox:nth-child(2n) {
        margin-right: 0;
      } */
    }
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .industrial {
    padding: 80px 2% 100px;
    .desc {
      text-align: left;
      font-size: 16px;
      line-height: 2.5;
    }
    .showBox {
      /* display: flex; */
      .itemBox {
        width: 31%;
        margin-right: 1%;
        margin-bottom: 30px;
        h3 {
          font-size: 18px;
          line-height: 2;
          text-align: left;
        }
        p {
          padding-top: 15px;
          a,
          span {
            font-size: 14px;
            line-height: 2;
          }
        }
      }
      .itemBox:nth-child(3n + 3) {
        margin-right: 0;
      }
    }
  }
}
@media (min-width: 1200px) {
  .industrial {
    padding: 80px 50px 100px;
    .desc {
      text-align: left;
      font-size: 18px;
      line-height: 2.5;
    }
    .showBox {
      /* display: flex; */
      .itemBox {
        width: 31%;
        margin-right: 3%;
        margin-bottom: 30px;
        h3 {
          font-size: 20px;
          line-height: 2;
          text-align: left;
        }
        p {
          padding-top: 30px;
          a,
          span {
            font-size: 16px;
            line-height: 2;
          }
        }
      }
      .itemBox:nth-child(3n + 3) {
        margin-right: 0;
      }
    }
  }
}
</style>
